import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    line-height: 160%\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  & > span {\n    color: ", "\n    opacity: 0.8;\n    margin: 10px 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 0.625rem;\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Name = styled.span(_templateObject(), function (props) {
  return props.theme.typography.boldFontWeight;
});
export var Wrapper = styled.div(_templateObject2(), media.xxLargeScreen(_templateObject3()), function (props) {
  return props.theme.colors.baseFont;
});